import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';

class HeroGridModal extends Controller {
  connect() {
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    });
  }

  disconnect() {
    $(this.sliderTarget).slick('unslick');
  }

  onTogglerClick() {
    this.openModal();
  }

  onItemClick({ currentTarget }) {
    const { index } = currentTarget.dataset;

    $(this.sliderTarget).slick('slickGoTo', parseInt(index, 10));

    const startVideo = currentTarget.dataset.type !== 'undefined' && currentTarget.dataset.type === 'video';

    this.openModal(startVideo);
  }

  openModal(startVideo = false) {
    this.modalTarget.classList.add('is-open');
    document.body.classList.toggle('overflow-y-hidden');

    if (startVideo) {
      this.startVideo();
    }
  }

  closeModal() {
    this.modalTarget.classList.remove('is-open');
    document.querySelector('body').classList.remove('overflow-y-hidden');

    this.pauseVideos();
  }

  startVideo() {
    if (!this.hasVideoTarget) return;

    const videoControllerEl = document.querySelector('[data-controller*="video"]');
    const videoController = this.application.getControllerForElementAndIdentifier(videoControllerEl, 'video');

    videoController.loadVideo(this.videoTarget);
  }

  pauseVideos() {
    const videos = toArray(this.sliderTarget.querySelectorAll('iframe, video'));

    videos.forEach((video) => {
      if (video.tagName.toLowerCase() === 'video') {
        video.pause();
      }

      if (video.tagName.toLowerCase() === 'iframe') {
        const videoSrc = video.src.replace('autoplay=1', 'autoplay=0');

        video.src = videoSrc;
        video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
      }
    });
  }
}

HeroGridModal.targets = [
  'modal',
  'slider',
  'video',
];

export default HeroGridModal;
